module.exports = __webpack_public_path__ + "img/1.078ef942.png";